// Reviewed
import React, { Component } from "react";
import axios from "axios";
import { SelectCategoryURL } from "../../APIServices/SelectCategoryRequest";
import PopularCategoriesPlaceholder from "./PopularCategoriesPlaceholder";
import Slider from "react-slick";
import ProductCard from "./ProductCard";
import { Link } from "react-router-dom";
import { ProductListCategoryURL } from "../../APIServices/ProductListRequest";
class PopularCategories extends Component {

  constructor() {
    super();
    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);

    this.state = {
      Next: function () {
        Slider.slickNext();
      },
      DataList: null,
      ProductList: [],
      SpecialOffer: "",
      nodata: false
    };
  }
  next() {
    this.slider.slickNext();
  }
  previous() {
    this.slider.slickPrev();
  }

  componentDidMount() {
    this.SelectCategory();
    this.SelectProductList()
  }
  SelectCategory = () => {
    axios.get(SelectCategoryURL()).then((res) => {
      this.setState({ DataList: res.data.categories, SpecialOffer: res.data.special_offer });
    });
  };

  SelectProductList=(code)=>{
    axios.get(ProductListCategoryURL('CAT18')).then((res)=>{
        if(res.status===200 && res.data.length>0){
            this.setState({ProductList:res.data})
        }
        else if(res.data.length===0){
            this.setState({nodata:true})
        }
        else{
            this.setState({nodata:true})
        }
    }).catch((err)=>{
        this.setState({nodata:true})
    })
}

  render() {
    let CategoryList = this.state.DataList;
    let CategoryListView = <PopularCategoriesPlaceholder />;

    if (CategoryList !== null) {
      // console.log( Array.isArray(CategoryList));
      CategoryListView = CategoryList.map((list, i) => {
        return (
          <li key={i} className="nav-item text-start m-2 my-sm-1 mx-sm-0 ">
            <Link
              
              className={`nav-link ${i === 0 ? 'active' : ''}`}
              to={"/ProductList/" + list["cat_code"]}
            >
              <img height="35px" src={list["cat_image"]} />
              {list["cat_name"]}
            </Link>
          </li>
        );
      });
    }

    let settings = {
      infinite: true,
      speed: 500,
      slidesToShow: 5,
      slidesToScroll: 1,
      dots: false,
      arrows: false,
      responsive: [
        {
          breakpoint: 1276,
          settings: {
            slidesToShow: 4,
          },
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
          },
        },
      ],
    };
    let products = this.state.ProductList;

    if (products.length > 0) {
      if (products.length < 6) {
        let i = 0;
        while (products.length < 6) {
          products.push(this.state.ProductList[i]);
          i++;
        }
      }
    }


    return (
      <>
        <div id="PopularCategory">
          <div className="container ">
            <div className="pb-3 pb-lg-5 d-flex justify-content-center justify-content-sm-between">
              <h3 className="SectionTitle">জনপ্রিয় ক্যাটেগরি</h3>
              <div className="CategoryCarousel d-none d-sm-block">
                <button
                  onClick={this.previous}
                  className="prev btn btn-outline-success rounded-circle"
                  style={{ marginRight: "10px" }}
                >
                  <i className="fa-solid fa-angle-left"></i>
                </button>
                <button
                  onClick={this.next}
                  className="next btn btn-outline-success rounded-circle"
                >
                  <i className="fa-solid fa-angle-right"></i>
                </button>
              </div>
            </div>
            <div className="row">
              <div className="CategoryList col-12 col-lg-3 pb-4">
                <ul className="nav flex-row justify-content-center flex-lg-column">
                  {CategoryListView}
                </ul>
              </div>
              <div className="CategoryListItem d-none d-sm-block col-12 col-lg-9">
                <Slider ref={(c) => (this.slider = c)} {...settings}>
                  {products.map((product, index) => (
                    <div key={index} className="Items">
                      <ProductCard product={product} />
                    </div>
                  ))}
                </Slider>
                <div className="ItemOffer d-flex align-items-center">
                  <button
                    className="btn  btn-success rounded-0 pt-2 pb-2"
                    style={{ width: "180px", marginRight: "10" }}
                  >
                    বিশেষ অফার
                  </button>
                  <marquee
                    direction="left"
                    height="100%"
                    style={{ background: "white", lineHeight: "50px" }}
                  >
                   {this.state.SpecialOffer}
                  </marquee>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default PopularCategories;
